/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CarveOutTrackingListEntryPayer } from './CarveOutTrackingListEntryPayer';
import {
    CarveOutTrackingListEntryPayerFromJSON,
    CarveOutTrackingListEntryPayerFromJSONTyped,
    CarveOutTrackingListEntryPayerToJSON,
    CarveOutTrackingListEntryPayerToJSONTyped,
} from './CarveOutTrackingListEntryPayer';
import type { PalAuthPlatformPayorForm } from './PalAuthPlatformPayorForm';
import {
    PalAuthPlatformPayorFormFromJSON,
    PalAuthPlatformPayorFormFromJSONTyped,
    PalAuthPlatformPayorFormToJSON,
    PalAuthPlatformPayorFormToJSONTyped,
} from './PalAuthPlatformPayorForm';
import type { CarveOutTrackingListEntryLead } from './CarveOutTrackingListEntryLead';
import {
    CarveOutTrackingListEntryLeadFromJSON,
    CarveOutTrackingListEntryLeadFromJSONTyped,
    CarveOutTrackingListEntryLeadToJSON,
    CarveOutTrackingListEntryLeadToJSONTyped,
} from './CarveOutTrackingListEntryLead';
import type { CarveOutMedicationSummary } from './CarveOutMedicationSummary';
import {
    CarveOutMedicationSummaryFromJSON,
    CarveOutMedicationSummaryFromJSONTyped,
    CarveOutMedicationSummaryToJSON,
    CarveOutMedicationSummaryToJSONTyped,
} from './CarveOutMedicationSummary';

/**
 * 
 * @export
 * @interface CarveOutTrackingListEntry
 */
export interface CarveOutTrackingListEntry {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    lead_id: string;
    /**
     * 
     */
    lead?: CarveOutTrackingListEntryLead;
    /**
     * 
     */
    payer?: CarveOutTrackingListEntryPayer;
    /**
     * 
     */
    auth_platform_form?: PalAuthPlatformPayorForm;
    /**
     * All non-deleted carve-out medications on this submission.
     */
    medications: Array<CarveOutMedicationSummary>;
    /**
     * Sum of cost_per_day across this submission's non-deleted carve-out medications.
     */
    total_daily_cost: number;
}

/**
 * Check if a given object implements the CarveOutTrackingListEntry interface.
 */
export function instanceOfCarveOutTrackingListEntry(value: object): value is CarveOutTrackingListEntry {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('lead_id' in value) || value['lead_id'] === undefined) return false;
    if (!('medications' in value) || value['medications'] === undefined) return false;
    if (!('total_daily_cost' in value) || value['total_daily_cost'] === undefined) return false;
    return true;
}

export function CarveOutTrackingListEntryFromJSON(json: any): CarveOutTrackingListEntry {
    return CarveOutTrackingListEntryFromJSONTyped(json, false);
}

export function CarveOutTrackingListEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): CarveOutTrackingListEntry {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'lead_id': json['lead_id'],
        'lead': json['lead'] == null ? undefined : CarveOutTrackingListEntryLeadFromJSON(json['lead']),
        'payer': json['payer'] == null ? undefined : CarveOutTrackingListEntryPayerFromJSON(json['payer']),
        'auth_platform_form': json['auth_platform_form'] == null ? undefined : PalAuthPlatformPayorFormFromJSON(json['auth_platform_form']),
        'medications': ((json['medications'] as Array<any>).map(CarveOutMedicationSummaryFromJSON)),
        'total_daily_cost': json['total_daily_cost'],
    };
}

export function CarveOutTrackingListEntryToJSON(json: any): CarveOutTrackingListEntry {
    return CarveOutTrackingListEntryToJSONTyped(json, false);
}

export function CarveOutTrackingListEntryToJSONTyped(value?: CarveOutTrackingListEntry | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'lead_id': value['lead_id'],
        'lead': CarveOutTrackingListEntryLeadToJSON(value['lead']),
        'payer': CarveOutTrackingListEntryPayerToJSON(value['payer']),
        'auth_platform_form': PalAuthPlatformPayorFormToJSON(value['auth_platform_form']),
        'medications': ((value['medications'] as Array<any>).map(CarveOutMedicationSummaryToJSON)),
        'total_daily_cost': value['total_daily_cost'],
    };
}

